import React, { useEffect, useRef, useState } from 'react'
import styles from './styles.module.scss'
import image_form from "../../../../images/education/image_form.jpg";
import FormContactsNew from "./form/FormContactsNew";

const contactsNew = ({ checkDomenNameState, setCheckRef, captchaSiteKey }) => {
  const [successSend, setSuccessSend] = useState(false)

  const checkRef = useRef(null)
  useEffect(() => {
    setCheckRef(checkRef)
  }, [])
  return (
    <div className={styles.wrapper} id="form">
      <div className={styles.left}>
        <p ref={checkRef} className={styles.title}>Если тебе интересны образовательные проекты Generium, давай будем на связи.</p>
      </div>
      <div className={styles.right}>
        <p ref={checkRef} className={styles.title}>
          <span>&rarr;</span> Оставь контакты
        </p>
        <div className={styles.form_block_wrapper}>
          <div className={styles.form_block_wrapper_image}>
            <img src={image_form} alt='vector' draggable='false'/>
          </div>
          <div className={styles.form_block_wrapper_form}>
            {successSend && (
              <div className={styles.wrapper_total_right_success}>
                <p className={styles.wrapper_total_right_success_p1}>
                  Данные отправлены!
                </p>
                <p>Мы внимательно ознакомимся с информацией.</p>
              </div>
            )}
            {!successSend && <FormContactsNew checkDomenNameState={checkDomenNameState} setSuccessSend={setSuccessSend} captchaSiteKey={captchaSiteKey} />}
          </div>
        </div>
      </div>
    </div>
  )
}

export default contactsNew
